import { render, staticRenderFns } from "./zuopinList.vue?vue&type=template&id=f4ceeb4e&"
import script from "./zuopinList.vue?vue&type=script&lang=js&"
export * from "./zuopinList.vue?vue&type=script&lang=js&"
import style0 from "./zuopinList.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports